import { useState } from "react";
import { navLinks, siteMeta, tickerItems } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header id="top" className="w-full">
      <div className="hidden bg-primary-500 text-background-50 md:block">
        <div className="flex w-full items-center justify-between px-8 py-2 text-xs">
          <span className="font-label tracking-wide">
            {siteMeta.issue} · {siteMeta.date} · {siteMeta.tagline}
          </span>
          <span className="flex items-center gap-5 font-label tracking-wide">
            <a href="#timeline" className="cursor-pointer transition-opacity hover:opacity-75">
              线索留档
            </a>
            <a href="#reactions" className="cursor-pointer transition-opacity hover:opacity-75">
              各方回应
            </a>
            <a href="#subscribe" className="cursor-pointer transition-opacity hover:opacity-75">
              订阅深扒
            </a>
          </span>
        </div>
      </div>

      <div className="sticky top-0 z-50 border-b border-background-300 bg-background-50/95 backdrop-blur">
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3.5 md:px-8 md:py-4">
          <h1 className="flex shrink-0 items-baseline gap-2">
            <a
              href="#top"
              className="cursor-pointer font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[28px]"
            >
              {siteMeta.name}
              <span className="text-primary-500">.</span>
            </a>
            <span className="hidden text-[11px] font-label tracking-[0.2em] text-foreground-500 sm:inline">
              深扒组
            </span>
          </h1>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2.5">
            <div className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-1.5 xl:flex">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-500" />
              </span>
              <input
                type="text"
                placeholder="检索人物、事件、合集"
                aria-label="检索人物、事件、合集"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
            <a
              href="#subscribe"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-bookmark-line text-base" />
              订阅深扒
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
            <nav className="grid grid-cols-2 gap-x-4 gap-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer rounded-md px-2 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <div className="mt-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-500" />
              </span>
              <input
                type="text"
                placeholder="检索人物、事件、合集"
                aria-label="检索人物、事件、合集"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
          </div>
        ) : null}
      </div>

      <div className="overflow-hidden border-b border-background-300 bg-background-100">
        <div className="flex w-full items-center gap-3 px-4 py-2.5 md:px-8">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-semibold tracking-wide text-primary-600">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-flashlight-fill text-[10px]" />
            </span>
            本期快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span key={`${item}-${i}`} className="text-xs text-foreground-600">
                  <span className="mr-2 text-accent-600">/</span>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}